import './index.scss';



/** WEBPACK FOOTER **
 ** ./src/SubjectContent/index.js
 **/